import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoDanes from '../../assets/logo-danes.png';
import logoPosgo from '../../assets/logo-posgo.png';
import fondoDanes from '../../assets/fondo-danes.png';

const WelcomeScreen = ({ onStart }) => {
    const navigate = useNavigate();
    const [isExiting, setIsExiting] = useState(false);

    const handleStart = () => {
        setIsExiting(true);
        setTimeout(() => {
            if (onStart) {
                onStart();
            } else {
                navigate('/products');
            }
        }, 500);
    };

    return (
        <div
            onClick={handleStart}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 50,
                cursor: 'pointer',
                overflow: 'hidden',
                opacity: isExiting ? 0 : 1,
                transform: isExiting ? 'scale(1.05)' : 'scale(1)',
                transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
                margin: 0,
                padding: 0,
                background: `linear-gradient(rgba(255,255,255,0.70), rgba(255,255,255,0.80)), url(${fondoDanes})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '60px',
            }}
        >
            <img
                src={logoDanes}
                alt="Danés"
                style={{
                    width: 'min(55vw, 520px)',
                    height: 'auto',
                    filter: 'drop-shadow(0 18px 40px rgba(0,0,0,0.22))',
                    animation: 'danesPulse 3s ease-in-out infinite',
                    pointerEvents: 'none',
                }}
            />

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '18px',
                pointerEvents: 'none',
            }}>
                <span style={{
                    fontSize: 'clamp(2rem, 5vw, 3.2rem)',
                    fontWeight: '800',
                    color: '#009542',
                    fontFamily: 'Quicksand, sans-serif',
                    letterSpacing: '1px',
                }}>
                    Toca para comenzar
                </span>
                <div style={{
                    width: '120px',
                    height: '4px',
                    borderRadius: '2px',
                    background: '#e1251b',
                    animation: 'danesPulse 3s ease-in-out infinite',
                }} />
            </div>

            <style>{`
                @keyframes danesPulse {
                    0%, 100% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.04); opacity: 0.85; }
                }
            `}</style>

            {/* Logo PosGo.cl abajo a la izquierda */}
            <div style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                zIndex: 9999,
                background: 'white',
                padding: '10px 18px',
                borderRadius: '14px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                pointerEvents: 'none',
            }}>
                <img
                    src={logoPosgo}
                    alt="PosGo"
                    style={{ height: '55px', width: 'auto', display: 'block' }}
                />
                <span style={{
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    color: '#db2113',
                    fontFamily: 'Quicksand, sans-serif',
                    lineHeight: 1,
                }}>
                    PosGo.cl
                </span>
            </div>
        </div>
    );
};

export default WelcomeScreen;
